import {mainColor, colorPalette} from './colors';
import {Box, Grid, BoxProps, Section} from './Layouts';

export {mainColor, colorPalette, Box, Grid, Section};
export type {BoxProps};
